import { indexToMiddle, middleToRing } from './fingerToFinger'
import { fingerTop, littleTop } from './fingerTop'
import { webKnots } from '../../../../common/back/lace/webKnots'
import { webKnotDownward, webKnotUpward } from 'src/features/brands/ragdelion/canvas/common/back/lace/webKnotSingle'
import { listCross } from './listCross'
import { State } from 'src/types'

const crossJointLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number) => {
  // 左上→右下
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(227 + x, 213 + y) //左上
  ctx.quadraticCurveTo(243 + x, 247 + y, 243 + x, 247 + y) //左下
  ctx.quadraticCurveTo(250 + x, 244 + y, 248 + x, 240 + y) //右下
  ctx.quadraticCurveTo(244 + x, 227 + y, 232 + x, 207 + y) //右上
  ctx.quadraticCurveTo(227 + x, 207 + y, 227 + x, 213 + y) //左上
  ctx.fill()
  ctx.moveTo(227 + x, 213 + y) //左下
  ctx.quadraticCurveTo(243 + x, 232 + y, 243 + x, 247 + y) //下
  ctx.stroke()
  ctx.closePath()

  // 左下→右上
  ctx.beginPath()
  ctx.moveTo(241 + x, 206 + y) //左上
  ctx.quadraticCurveTo(225 + x, 249 + y, 225 + x, 245 + y) //左下
  ctx.quadraticCurveTo(233 + x, 248 + y, 233 + x, 248 + y) //右下左
  ctx.quadraticCurveTo(245 + x, 218 + y, 245 + x, 218 + y) //右下右
  ctx.quadraticCurveTo(245 + x, 211 + y, 241 + x, 206 + y) //左上
  ctx.fill()
  ctx.moveTo(241 + x, 209 + y) //左上
  ctx.quadraticCurveTo(240 + x, 229 + y, 225 + x, 245 + y) //左下
  ctx.stroke()
  ctx.closePath()
}

export const lace = (ctx: CanvasRenderingContext2D, color: string, state: State): void => {
  webKnots(ctx, color, 70, -910, 75, 0.8) // 親指の結び目

  webKnotDownward(ctx, color, 0, 0) // 親指先端の下向きの1つ結びの紐

  fingerTop(ctx, color, 0, 0) // 人差し指先端
  fingerTop(ctx, color, -160, 115, -15) // 中指先端
  fingerTop(ctx, color, -343, 218, -35) // 薬指先端
  littleTop(ctx, color) // 小指先端

  indexToMiddle(ctx, color) // 人差し指と中指の連結
  middleToRing(ctx, color, 10, 0) // 中指と薬指の連結
  middleToRing(ctx, color, -10, 100, 0.8) // 薬指と小指の連結

  // 親指とウェブの間の上向きの1つ結びの紐
  webKnotUpward(ctx, color, -55, 10)

  const isSUN01W = state?.baseModel.productNumber === 'SUN-01W'
  if (isSUN01W) {
    crossJointLace(ctx, color, 0, 0) // クロス部分
    crossJointLace(ctx, color, 5, 70) // クロス部分
    webKnotDownward(ctx, color, -450, -85, 1, 0.8) // 親指とウェブの間の下向きの1つ結びの紐
  }

  listCross(ctx, color) // 手口左のクロス部分
  webKnots(ctx, color, -170, 400, 10, 0.8) // 手首ベルト左の結び目
}
